<!--根据节日来渲染图片 view:4-->

<template>
    <div class="view4Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <div class="v4ItemsNull shadowRadius positionFix" :style="`background:${list.color}`">
            <div class="monthShow">
                <div class="monthPos">
             <div class="month">{{list.month}}</div>
                <div class="monthEn" :style="`background:${list.color}`">{{list.monthEn}}</div>
                </div>
            </div>
            <div class="line"></div>
            <div class="dateFor">
                {{list.date}}
            </div>
            <div class="descName holidayRadius" v-if="list.name&&!list.value">
          {{list.name}}
            </div>
            <div class="descValue" v-html="list.value" v-else>
<!--                {{list.value}}-->
            </div>
        </div>
    </div>
</template>


<script>
    import {mapState, mapActions, mapMutations} from "vuex";

    export default {
        name: "View4",
        components: {},
        props: {
            list: {
                type: Object,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {

            };

        },
        methods: {}
    };
</script>
<style lang="less" scoped>
    .view4Wrapper {
        width: 100%;



        .positionFix {
            position: relative;
            .monthShow{
                position: absolute;
                left: .3rem;
                top: .4rem;
                .monthPos{
                    position: relative;
                }
                .month{
                    color: #fff;
                    font-size: 3.3rem;
                    font-family:DINCondensedC,STFangsong;
                    letter-spacing: .12rem;

                }

                .monthEn{
                   width: 2.8rem;
                    height: .5rem;
                    color: #fff;
                    font-size: .3rem;
                    text-align: center;
                    display: flex;
                    font-family:FangSong,STFangsong;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }

            }
            .line{
                width: .02rem;
                height: 5.5rem;
                position: absolute;
                left: 50%;
                top: 50%;
                background: rgba(255,255,255,.7);
                transform: translate(-50%,-50%) rotate(45deg);
            }
            .dateFor {
                letter-spacing: .1rem;
                color: rgba(51,51,51,.5);
                font-family:FangSong,STFangsong;
                writing-mode: vertical-lr;
                font-size: .30rem;
                position: absolute;
                left: 3.4rem;
                top: 0.97rem;
            }
            .descValue{
                font-family:PingFangSC-Regular,PingFang SC;
                color: rgba(25,25,25,.8);
                font-size: .35rem;
                position: absolute;
                right: .6rem;
                bottom: 0.97rem;
                max-width: 3rem;
                text-align: right;
                line-height: .5rem;
            }
            .descName{
                padding: .4rem .3rem;

                background: rgba(255,255,255,.5);
                writing-mode: vertical-lr;
                color: rgba(25,25,25,1);
                font-size: .6rem;
                letter-spacing: .2rem;
                position: absolute;
                right: .6rem;
                bottom: 0.97rem;
                max-width: 3rem;
                text-align: right;
                line-height: .5rem;
            }
        }

        .v4ItemsNull {
            margin-top: .3rem;
            width: 8.6rem;
            height: 7.5rem;

            overflow: hidden;


        }

        .v4Items {
            cursor: pointer;
            padding: .12rem 0;

            .link {
                color: #3DAADD;
                font-size: .32rem;
                margin-top: .2rem;
            }

            .imgLinkBox {
                width: 8.6rem;
                height: 7.2rem;
                border-radius: .2rem .45rem .45rem .45rem;
                box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

    }

</style>
